import React from 'react';

export default ({
  label = '',
  value = [],
  onChange,
  // style = {},
}) => {
  const [min = 0, max = 0] = value;

  const changeMinHandler = (minValue) => {
    onChange([parseInt(minValue, 10), max]);
  };

  const changeMaxHandler = (maxValue) => {
    onChange([min, parseInt(maxValue, 10)]);
  };

  return (
    <div className="range-basic">
      <span className="range-basic-label">{label}</span>

      <div className="range-basic-fields">
        <div className="range-basic-field">
          <span>Min</span>
          <input type="number" value={min} onChange={(e) => changeMinHandler(e.target.value)} />
        </div>
        <span>&mdash;</span>
        <div className="range-basic-field">
          <input type="number" value={max} onChange={(e) => changeMaxHandler(e.target.value)} />
          <span>Max</span>
        </div>
      </div>
    </div>
  );
};
